import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class TextoTermosContratacao extends BaseEntity {
    termosContratacao: string;
    termosEnvioDevolucaoHonra: string;
    termosInformeLiquidacaoOperacao: string;
}
